import React, {Component} from "react";
import {getWindowDimensions, hideHeader} from "../../../actions/actionCreators";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import withStyles from "@material-ui/core/styles/withStyles";
import agent from "../../../agent";
import NavigationButtons from "./NavigationButtons";
import leaderboardImg from "./leaderboard.png";
import Grid from "@material-ui/core/Grid";
const styles = (theme) => ({
    root: {
        background: "url('/orders/images/main-bg.png')",
        position: "fixed"
    },
    secondRoot: {
        maxWidth:600,
        padding: "20px",
        margin: "0 auto",
    },
    highlight: {
        backgroundColor: theme.palette.primary.border,
        color: "#fff"
    }
});
class NowrouzGameLeaderboard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        hideHeader()
    }

    componentDidMount() {
        agent.NowrouzGame.getLeaderboard()
            .then((res) => {
                if (res && res.data)
                    this.setState({rows: res.data})
            })
    }

    render() {
        const {
            props: {
                classes
            },
            state: {
                rows
            } = {}
        } = this
        const {height, width} = getWindowDimensions();

        return <div className={classes.root} style={{height: height}}>
            <div className={classes.secondRoot}>
                <Grid container justifyContent={"center"}>
                    <img style={{width: "100%"}} alt="prizes" src={leaderboardImg}/>
                </Grid>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>نام</TableCell>
                                <TableCell>امتیاز</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows
                                    ?
                                    rows.map((row,index) => (
                                        <TableRow key={row.name} className={row["him/her"] ? classes.highlight : null}>
                                            <TableCell>
                                                {(index+1) > 10 ? "#" : (index+1) }
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell>
                                                {row.best_score}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    :
                                    Array(10).fill("").map((row,index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {index+1}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <Skeleton/>
                                            </TableCell>
                                            <TableCell><Skeleton/></TableCell>
                                        </TableRow>
                                    ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <NavigationButtons/>
            </div>
        </div>
    }
}

export default withStyles(styles)(NowrouzGameLeaderboard);